import React from 'react';
interface BonusCardProps {
  title: string;
  description: string;
  value: string;
  imageSrc: string;
  checkoutUrl?: string;
}
const CHECKOUT_URL = 'https://checkout.impulsodigitalx.shop/cart/45711849652385:1';
export function BonusCard({
  title,
  description,
  value,
  imageSrc,
  checkoutUrl = CHECKOUT_URL
}: BonusCardProps) {
  return <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="block rounded-2xl overflow-hidden transform transition-transform hover:scale-105 group cursor-pointer bg-white shadow-md border border-brand-border" style={{
    textDecoration: 'none'
  }} data-id="element-5">
      <div className="bg-brand-coral text-white text-center py-2.5 font-black uppercase tracking-widest text-sm" data-id="element-6">
        🎁 GRATIS POR HOY
      </div>

      <div className="aspect-square w-full relative overflow-hidden bg-brand-cream" data-id="element-7">
        <img src={imageSrc} alt={title} className="w-full h-full object-contain" data-id="element-8" />
      </div>

      <div className="p-5" data-id="element-9">
        <h3 className="text-lg font-black text-brand-brown mb-1 uppercase leading-tight" data-id="element-10">
          {title}
        </h3>
        <p className="text-brand-brown-light text-sm mb-3" data-id="element-11">{description}</p>
        <div className="flex items-center justify-between border-t border-brand-border pt-3" data-id="element-12">
          <span className="text-brand-brown-light/60 line-through text-sm" data-id="element-13">
            Valor: {value}
          </span>
          <span className="text-brand-sage font-black uppercase text-sm" data-id="element-14">
            ¡GRATIS!
          </span>
        </div>
      </div>
    </a>;
}